<div class="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-md animate-fade-in"
    (click)="onCancel()">

    <div class="bg-white dark:bg-slate-800 w-full max-w-5xl max-h-[92vh] rounded-[2.5rem] shadow-[0_20px_100px_rgba(0,0,0,0.2)] flex flex-col relative animate-fade-in-up z-[110] overflow-hidden"
        (click)="onClickInsideModal($event)">

        <!-- Header -->
        <div
            class="px-8 py-6 border-b border-slate-100 dark:border-slate-700 flex items-center justify-between bg-white/50 dark:bg-slate-800/50 backdrop-blur-xl sticky top-0 z-20">
            <div class="flex items-center gap-4">
                <div class="w-12 h-12 rounded-2xl bg-amber-50 dark:bg-amber-900/30 flex items-center justify-center">
                    <span class="material-icons text-amber-500 text-2xl">sensors</span>
                </div>
                <div>
                    <h2 class="text-xl font-black text-slate-800 dark:text-slate-100 tracking-tight">
                        จุดให้บริการ / {{ spotData ? 'แก้ไขข้อมูล' : 'สร้างใหม่' }}
                    </h2>
                    <p
                        class="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-[0.2em] mt-0.5">
                        Configuration & Device Parameters</p>
                </div>
            </div>

            <div class="flex items-center gap-3">
                <button (click)="onCancel()"
                    class="px-5 py-2.5 rounded-xl text-slate-500 dark:text-slate-400 font-bold hover:bg-slate-100 dark:hover:bg-slate-700 transition-all text-xs uppercase tracking-widest">ยกเลิก</button>
                <button (click)="onSave()" [disabled]="isLoading"
                    class="px-8 py-2.5 bg-amber-400 hover:bg-amber-500 text-white font-black rounded-xl shadow-[0_8px_20px_rgba(251,191,36,0.25)] hover:-translate-y-0.5 transition-all flex items-center gap-2 text-xs uppercase tracking-widest">
                    <span *ngIf="isLoading"
                        class="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span>
                    บันทึก
                </button>
            </div>
        </div>

        <!-- Form Area -->
        <div class="flex-1 overflow-y-auto p-12 custom-scrollbar">
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-x-16 gap-y-6">

                <!-- Left Section (General Info) -->
                <div class="space-y-5">
                    <!-- ID (Display only) -->
                    <div class="grid grid-cols-3 items-center">
                        <label class="text-xs font-black text-slate-500 uppercase tracking-widest">ID</label>
                        <div class="col-span-2 text-sm font-black text-slate-400 font-mono">{{ form.id || '-' }}</div>
                    </div>

                    <!-- ชื่อจุดให้บริการ -->
                    <div class="grid grid-cols-3 items-center gap-4">
                        <label class="text-xs font-black text-slate-700 dark:text-slate-300">ชื่อจุดให้บริการ</label>
                        <div class="col-span-2">
                            <input type="text" [(ngModel)]="form.name" placeholder="ชื่อจุด"
                                class="w-full h-10 px-4 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-xl text-sm font-bold focus:bg-white focus:ring-4 focus:ring-amber-50 transition-all outline-none">
                        </div>
                    </div>

                    <!-- รายละเอียดจุดบริการ -->
                    <div class="grid grid-cols-3 items-start gap-4">
                        <label
                            class="text-xs font-black text-slate-700 dark:text-slate-300 mt-3">รายละเอียดจุดบริการ</label>
                        <div class="col-span-2">
                            <textarea [(ngModel)]="form.description" placeholder="รายละเอียด" rows="3"
                                class="w-full px-4 py-3 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-xl text-sm font-bold focus:bg-white transition-all outline-none resize-none"></textarea>
                        </div>
                    </div>

                    <!-- POS ID -->
                    <div class="grid grid-cols-3 items-center gap-4">
                        <label class="text-xs font-black text-slate-700 dark:text-slate-300 font-mono">POS ID</label>
                        <div class="col-span-2">
                            <input type="text" [(ngModel)]="form.posId" placeholder="POS-XXXX"
                                class="w-full h-10 px-4 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-xl text-sm font-bold outline-none font-mono">
                        </div>
                    </div>

                    <!-- IP -->
                    <div class="grid grid-cols-3 items-center gap-4">
                        <label
                            class="text-xs font-black text-slate-700 dark:text-slate-300 font-mono uppercase tracking-widest">IP
                            Address</label>
                        <div class="col-span-2">
                            <input type="text" [(ngModel)]="form.ip" placeholder="192.168.x.x"
                                class="w-full h-10 px-4 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-xl text-sm font-bold outline-none font-mono">
                        </div>
                    </div>

                    <!-- ประเภทจุดให้บริการ -->
                    <div class="grid grid-cols-3 items-center gap-4">
                        <label class="text-xs font-black text-slate-700 dark:text-slate-300">ประเภทจุดให้บริการ</label>
                        <div class="col-span-2 relative">
                            <div class="relative flex items-center">
                                <input type="text" [(ngModel)]="searchSpotTypeText" placeholder="เลือกหรือพิมพ์ค้นหา..."
                                    (focus)="onInputFocus('typeSelect')"
                                    (click)="onInputFocus('typeSelect'); $event.stopPropagation()"
                                    (blur)="closeDropdowns()"
                                    class="w-full h-10 px-4 pr-10 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-xl text-sm font-bold focus:bg-white dark:focus:bg-slate-800 focus:ring-4 focus:ring-amber-50 dark:focus:ring-amber-900/30 outline-none transition-all placeholder:font-normal placeholder:text-slate-400">
                                <span
                                    class="material-icons text-slate-400 text-sm absolute right-4 transition-transform pointer-events-none cursor-pointer"
                                    [class.rotate-180]="openDropdown==='typeSelect'">expand_more</span>
                            </div>
                            <div *ngIf="openDropdown === 'typeSelect'" (mousedown)="$event.preventDefault()"
                                class="absolute top-full left-0 right-0 mt-2 z-[130] bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-2 max-h-48 overflow-y-auto animate-fade-in-up">
                                <div *ngIf="filteredSpotTypes.length === 0"
                                    class="px-4 py-3 text-sm text-slate-400 text-center font-bold">ไม่พบข้อมูลที่ค้นหา
                                </div>
                                <div *ngFor="let t of filteredSpotTypes" (click)="selectOption('spotType', t)"
                                    class="px-4 py-2.5 text-sm font-bold hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 cursor-pointer transition-all">
                                    {{ t }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- พื้นที่ให้บริการ -->
                    <div class="grid grid-cols-3 items-center gap-4">
                        <label class="text-xs font-black text-slate-700 dark:text-slate-300">พื้นที่ให้บริการ</label>
                        <div class="col-span-2 relative">
                            <div class="relative flex items-center">
                                <input type="text" [(ngModel)]="searchAreaText" placeholder="เลือกหรือพิมพ์ค้นหา..."
                                    (focus)="onInputFocus('areaSelect')"
                                    (click)="onInputFocus('areaSelect'); $event.stopPropagation()"
                                    (blur)="closeDropdowns()"
                                    class="w-full h-10 px-4 pr-10 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-xl text-sm font-bold focus:bg-white dark:focus:bg-slate-800 focus:ring-4 focus:ring-amber-50 dark:focus:ring-amber-900/30 outline-none transition-all placeholder:font-normal placeholder:text-slate-400">
                                <span
                                    class="material-icons text-slate-400 text-sm absolute right-4 transition-transform pointer-events-none cursor-pointer"
                                    [class.rotate-180]="openDropdown==='areaSelect'">expand_more</span>
                            </div>
                            <div *ngIf="openDropdown === 'areaSelect'" (mousedown)="$event.preventDefault()"
                                class="absolute top-full left-0 right-0 mt-2 z-[130] bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-2 max-h-48 overflow-y-auto animate-fade-in-up">
                                <div *ngIf="filteredAreas.length === 0"
                                    class="px-4 py-3 text-sm text-slate-400 text-center font-bold">ไม่พบข้อมูลที่ค้นหา
                                </div>
                                <div *ngFor="let a of filteredAreas" (click)="selectOption('area', a)"
                                    class="px-4 py-2.5 text-sm font-bold hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 cursor-pointer transition-all">
                                    {{ a }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- ประเภทรถ -->
                    <div class="grid grid-cols-3 items-center gap-4">
                        <label class="text-xs font-black text-slate-700 dark:text-slate-300">ประเภทรถ</label>
                        <div class="col-span-2 relative">
                            <div class="relative flex items-center">
                                <input type="text" [(ngModel)]="searchVehicleTypeText"
                                    placeholder="เลือกหรือพิมพ์ค้นหา..." (focus)="onInputFocus('vTypeSelect')"
                                    (click)="onInputFocus('vTypeSelect'); $event.stopPropagation()"
                                    (blur)="closeDropdowns()"
                                    class="w-full h-10 px-4 pr-10 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-xl text-sm font-bold focus:bg-white dark:focus:bg-slate-800 focus:ring-4 focus:ring-amber-50 dark:focus:ring-amber-900/30 outline-none transition-all placeholder:font-normal placeholder:text-slate-400">
                                <span
                                    class="material-icons text-slate-400 text-sm absolute right-4 transition-transform pointer-events-none cursor-pointer"
                                    [class.rotate-180]="openDropdown==='vTypeSelect'">expand_more</span>
                            </div>
                            <div *ngIf="openDropdown === 'vTypeSelect'" (mousedown)="$event.preventDefault()"
                                class="absolute top-full left-0 right-0 mt-2 z-[130] bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-2 max-h-48 overflow-y-auto animate-fade-in-up">
                                <div *ngIf="filteredVehicleTypes.length === 0"
                                    class="px-4 py-3 text-sm text-slate-400 text-center font-bold">ไม่พบข้อมูลที่ค้นหา
                                </div>
                                <div *ngFor="let v of filteredVehicleTypes" (click)="selectOption('vehicleType', v)"
                                    class="px-4 py-2.5 text-sm font-bold hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 cursor-pointer transition-all">
                                    {{ v }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Right Section (Technical & SAP) -->
                <div class="space-y-5">
                    <!-- API User -->
                    <div class="grid grid-cols-3 items-center gap-4">
                        <label class="text-xs font-black text-slate-500 uppercase tracking-widest">รหัสสมาชิก</label>
                        <div class="col-span-2">
                            <input type="text" [(ngModel)]="form.apiUser" placeholder="Username"
                                class="w-full h-10 px-4 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-xl text-sm font-bold outline-none">
                        </div>
                    </div>

                    <!-- API Pass -->
                    <div class="grid grid-cols-3 items-center gap-4">
                        <label class="text-xs font-black text-slate-500 uppercase tracking-widest">รหัสผ่าน</label>
                        <div class="col-span-2">
                            <input type="password" [(ngModel)]="form.apiPass" placeholder="••••••••"
                                class="w-full h-10 px-4 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-xl text-sm font-bold outline-none tracking-[0.3em]">
                        </div>
                    </div>

                    <!-- Connect Date -->
                    <div class="grid grid-cols-3 items-center gap-4">
                        <label class="text-xs font-black text-slate-500 uppercase tracking-widest">วันที่เชื่อมต่อ
                            <!-- (Connect Date) -->
                        </label>
                        <div class="col-span-2 relative">
                            <input type="text" [(ngModel)]="form.connectDate" placeholder="YYYY-MM-DD HH:MM:SS"
                                class="w-full h-10 px-10 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-xl text-sm font-bold outline-none font-mono">
                            <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 "
                                style="font-size: 18px;">calendar_today</span>
                        </div>
                    </div>

                    <!-- Monitor & Status Group -->
                    <div class="grid grid-cols-3 items-center gap-4">
                        <label class="text-xs font-black text-slate-500 uppercase tracking-widest">สถานะ / เชื่อมต่อ
                        </label>
                        <div class="col-span-2">
                            <input type="text" [(ngModel)]="form.monitor"
                                class="w-full h-10 px-4 bg-emerald-50/50 dark:bg-emerald-900/10 border border-emerald-100 dark:border-emerald-800 rounded-xl text-sm font-black text-emerald-600 outline-none uppercase tracking-widest">
                        </div>
                    </div>

                    <div class="grid grid-cols-3 items-center gap-4">
                        <label class="text-xs font-black text-slate-500 uppercase tracking-widest">สถานะ</label>
                        <div class="col-span-2">
                            <input type="text" [(ngModel)]="form.status" placeholder="Active"
                                class="w-full h-10 px-4 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-xl text-sm font-bold outline-none uppercase tracking-widest">
                        </div>
                    </div>

                    <!-- Device Key -->
                    <div class="grid grid-cols-3 items-center gap-4">
                        <label class="text-xs font-black text-slate-500 uppercase tracking-widest">รหัสอุปกรณ์ (Device
                            Key)</label>
                        <div class="col-span-2">
                            <input type="text" [(ngModel)]="form.deviceKey" placeholder="KEY-XXXX"
                                class="w-full h-10 px-4 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-xl text-sm font-bold outline-none font-mono uppercase tracking-widest">
                        </div>
                    </div>

                    <!-- Default Rate -->
                    <div class="grid grid-cols-3 items-center gap-4">
                        <label
                            class="text-xs font-black text-slate-500 uppercase tracking-widest">อัตราค่าบริการ</label>
                        <div class="col-span-2 relative">
                            <div class="relative flex items-center">
                                <input type="text" [(ngModel)]="searchRateText" placeholder="เลือกหรือพิมพ์ค้นหา..."
                                    (focus)="onInputFocus('rateSelect')"
                                    (click)="onInputFocus('rateSelect'); $event.stopPropagation()"
                                    (blur)="closeDropdowns()"
                                    class="w-full h-10 px-4 pr-10 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-xl text-sm font-bold focus:bg-white dark:focus:bg-slate-800 focus:ring-4 focus:ring-amber-50 dark:focus:ring-amber-900/30 outline-none transition-all placeholder:font-normal placeholder:text-slate-400">
                                <span
                                    class="material-icons text-slate-400 text-sm absolute right-4 transition-transform pointer-events-none cursor-pointer"
                                    [class.rotate-180]="openDropdown==='rateSelect'">expand_more</span>
                            </div>
                            <div *ngIf="openDropdown === 'rateSelect'" (mousedown)="$event.preventDefault()"
                                class="absolute bottom-full left-0 right-0 mb-2 z-[130] bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-2 max-h-48 overflow-y-auto animate-fade-in-up">
                                <div *ngIf="filteredRates.length === 0"
                                    class="px-4 py-3 text-sm text-slate-400 text-center font-bold">ไม่พบข้อมูลที่ค้นหา
                                </div>
                                <div *ngFor="let r of filteredRates" (click)="selectOption('defaultRate', r)"
                                    class="px-4 py-2.5 text-sm font-bold hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 cursor-pointer transition-all">
                                    {{ r }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Prefix / SAP Group -->
                    <div class="grid grid-cols-3 gap-4">
                        <div class="flex flex-col gap-1.5 col-span-1">
                            <label
                                class="text-[9px] font-black text-slate-400 uppercase tracking-[0.2em] pl-1">หัวรหัส</label>
                            <input type="text" [(ngModel)]="form.prefix" placeholder="101"
                                class="w-full h-10 px-4 bg-slate-50 border border-slate-100 rounded-xl text-sm font-bold outline-none">
                        </div>
                        <div class="flex flex-col gap-1.5 col-span-2">
                            <label class="text-[9px] font-black text-slate-400 uppercase tracking-[0.2em] pl-1">ชื่อ
                                SAP</label>
                            <input type="text" [(ngModel)]="form.sapName" placeholder="N-XXXX"
                                class="w-full h-10 px-4 bg-slate-50 border border-slate-100 rounded-xl text-sm font-bold outline-none">
                        </div>
                    </div>

                    <div
                        class="grid grid-cols-3 items-center gap-4 text-xs font-black text-slate-500 uppercase tracking-widest">
                        <label>ชื่อ SAP M</label>
                        <div class="col-span-2">
                            <input type="text" [(ngModel)]="form.sapNameM" placeholder="M-XXXX"
                                class="w-full h-10 px-4 bg-slate-50 border border-slate-100 rounded-xl text-sm font-bold outline-none">
                        </div>
                    </div>

                    <!-- Site Dropdown -->
                    <div class="grid grid-cols-3 items-center gap-4">
                        <label class="text-xs font-black text-amber-500 uppercase tracking-widest">พื้นที่บริการ</label>
                        <div class="col-span-2 relative">
                            <div class="relative flex items-center">
                                <input type="text" [(ngModel)]="searchSiteText"
                                    placeholder="เลือกหรือพิมพ์ค้นหาพื้นที่..." (focus)="onInputFocus('siteSelect')"
                                    (click)="onInputFocus('siteSelect'); $event.stopPropagation()"
                                    (blur)="closeDropdowns()"
                                    class="w-full h-10 px-4 pr-10 bg-amber-50/30 dark:bg-slate-900 border border-amber-100/50 dark:border-slate-800 rounded-xl text-sm font-bold text-amber-600 focus:bg-white dark:focus:bg-slate-800 focus:ring-4 focus:ring-amber-50 dark:focus:ring-amber-900/30 outline-none transition-all placeholder:font-normal placeholder:text-amber-400/70">
                                <span
                                    class="material-icons text-amber-400 text-sm absolute right-4 transition-transform pointer-events-none cursor-pointer"
                                    [class.rotate-180]="openDropdown==='siteSelect'">expand_more</span>
                            </div>
                            <div *ngIf="openDropdown === 'siteSelect'" (mousedown)="$event.preventDefault()"
                                class="absolute bottom-full left-0 right-0 mb-2 z-[130] bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-2 max-h-[150px] overflow-y-auto animate-fade-in-up">
                                <div *ngIf="filteredSites.length === 0"
                                    class="px-4 py-3 text-sm text-slate-400 text-center font-bold">ไม่พบข้อมูลที่ค้นหา
                                </div>
                                <div *ngFor="let s of filteredSites" (click)="selectOption('site', s.name)"
                                    class="px-4 py-2.5 text-sm font-bold hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 transition-all cursor-pointer">
                                    {{ s.name }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Check Code -->
                    <div class="grid grid-cols-3 items-center gap-4">
                        <label class="text-xs font-black text-slate-500 uppercase tracking-widest">รหัสตรวจสอบ</label>
                        <div class="col-span-2 text-sm font-bold">
                            <input type="text" [(ngModel)]="form.checkCode" placeholder="CODE-123"
                                class="w-full h-10 px-4 bg-slate-50 border border-slate-100 rounded-xl text-sm font-bold outline-none">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>